function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#pure_to_pure);}.cls-2{fill:url(#pure_to_pure-2);}.cls-3{fill:url(#pure_to_pure-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pure_to_pure",
  x1: 50.02,
  y1: 235.9,
  x2: 388.84,
  y2: 261.96,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#1fc3f3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4cbfac"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pure_to_pure-2",
  x1: 50.02,
  y1: 235.9,
  x2: 388.84,
  y2: 261.97,
  xlinkHref: "#pure_to_pure"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pure_to_pure-3",
  x1: 50.74,
  y1: 226.54,
  x2: 389.56,
  y2: 252.6,
  xlinkHref: "#pure_to_pure"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M153.69,161.71a82.17,82.17,0,1,0,82.16,82.16A82.16,82.16,0,0,0,153.69,161.71Zm0,146.63a64.47,64.47,0,1,1,64.46-64.47A64.54,64.54,0,0,1,153.69,308.34Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M162.54,247.37V223.84a8.85,8.85,0,0,0-17.7,0v23.53a13.91,13.91,0,0,0-5.58,11,14.43,14.43,0,0,0,28.86,0A13.91,13.91,0,0,0,162.54,247.37Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M406.7,20c-41.11,0-73.31,36.25-73.31,82.52,0,29.79,21.31,91.73,60.38,99l5.16,1V369.83a92.51,92.51,0,0,1-182.21,22.73L215,385.91c27.55-3,45.22-7.47,52.08-9.37l11-3.62c12-5.44,17.58-12.5,17.58-21.54V93.31c0-24.18-46.37-36.44-137.82-36.44S20,69.13,20,93.31V351.38c0,8.61,5.28,15.12,17,20.69l8.84,3.13c32.15,10.29,59.83,13.59,113.92,13.59,14,0,26.54-.54,37.95-1.35l.94,4.55c10.51,51,55.8,88,107.7,88A110.29,110.29,0,0,0,416.51,369.83V202.27l4.87-1.15c38.49-9.11,58.62-69,58.62-98.6C480,56.25,447.8,20,406.7,20ZM39.92,90.54c11.68-9.47,60.17-16.09,117.92-16.09s106.09,6.6,117.85,16.06l-9.28,2.8c-20,6.76-57.91,13.77-106.67,13.77-54.79,0-80-3.13-112.38-14l-7.48-2.55ZM159.74,371.21c-54.79,0-80-3.13-112.38-13.95l-9.78-3.34V108.42l8.24,2.64c32.15,10.29,59.83,13.59,113.92,13.59,60,0,96.67-9.29,107.37-12.24l11-3.62V353.92l-11.67,3.53C246.41,364.21,208.5,371.21,159.74,371.21Zm255-186.57a59,59,0,0,1-8.24.61,52.41,52.41,0,0,1-8.09-.64C370.61,181,351,129.22,351,102.52c0-36.41,24.48-64.94,55.74-64.94s55.72,28.53,55.72,64.94C462.42,129.22,442.78,181,414.78,184.64Z"
});

var SvgIconBloodPressure = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 500 500",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconBloodPressure, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_bloodPressure.482d713b.svg";
export { ForwardRef as ReactComponent };